import { createAction } from '@reduxjs/toolkit';

export const spacerRequest = createAction('spacer/request');
export const spacerError = createAction('spacer/error');
export const spacerUpdateStore = createAction('spacer/updateStore');
export const spacerStore = createAction('spacer/store');
export const spacerClear = createAction('spacer/clear');

export const spacerUpdateId = createAction('spacer/updateId');
export const spacerUpdateUID = createAction('spacer/updateUID');
export const spacerUpdateSID = createAction('spacer/updateSID');
export const spacerUpdateIsAdded = createAction('spacer/updateIsAdded');
export const spacerUpdateIsActive = createAction('spacer/updateIsActive');
export const spacerUpdateValue = createAction('spacer/updateValue');
